<ng-template #viewContainer></ng-template>